<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-xs-12 font-size-13 cl-primary font-weight-bold">Jasa Pengiriman</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-3">
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-form ref="formCourier">
						<v-row>
							<v-col cols="12">
								<v-autocomplete hide-details="auto" label="Jasa Pengiriman" color="primary" no-data-text="Belum ada data yang dapat ditampilkan" :rules="rules.courier" required :items="courierRajaongkir" item-text="courier_name" item-value="courier_id" v-model="id_courier" @change="getCost"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="pt-3 text-center" v-if="loading_cost">
									<v-progress-circular indeterminate size="45" width="4" color="primary"></v-progress-circular>
								</div>
								<div v-else>
									<template v-if="costRajaongkir.length > 0">
										<v-radio-group v-model="radioGroup" v-if="costRajaongkir[0].costs.length > 0">
											<v-radio v-for="(service, i) in costRajaongkir[0].costs" :key="i" :value="i" @click="chooseService(costRajaongkir[0], i)">
												<template v-slot:label>
													<div class="pb-1 d-block">
														<div class="cl-dark-green font-size-10">{{ service.description }}<span class="pl-2 red--text text--lighten-2">{{ service.cost[0].value | toRupiah }}</span></div>
														<div class="cl-light-grey font-size-10" v-if="service.cost[0].etd">Estimasi sampai {{ service.cost[0].etd }} hari</div>
													</div>
												</template>
											</v-radio>
										</v-radio-group>
										<div class="pt-3 cl-dark-green font-size-xs-10 font-size-12" v-else>Tidak ada jasa pengiriman yang tersedia</div>
									</template>
								</div>
							</v-col>
						</v-row>
					</v-form>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="12" class="text-center">
					<v-btn depressed color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" :loading="loading_cost" :disabled="btn_disabled" @click="saveCourier">
						<span class="pr-2 font-size-xs-10 font-size-11">Simpan</span>
						<v-icon>mdi-content-save-outline</v-icon>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			radioGroup: '',
			btn_disabled: true,
			loading_cost: false,
			id_courier: '',
			cost_data: '',
			courier_data: {},
			rules: {
				courier: [v => !!v || 'Jasa Pengiriman tidak boleh kosong'],
			},
			
		}
	},
	computed:{
		...mapState('option', ['courierRajaongkir', 'costRajaongkir']),
	},
	props: {
	},
	methods :{
		...mapActions('option', ['getCourierRajaongkir', 'getCostRajaongkir']),
		...mapMutations('option', ['clearOptions']),

		modalShow(data) {
			this.cost_data = Object.assign(data)
			this.dialog = true
			this.getCourierRajaongkir()
		},
		modalHide() {
			this.dialog = false
			this.reset()
		},
		reset() {
			this.clearOptions()
			this.$refs.formCourier.reset()
			this.btn_disabled = true
		},
		getCost() {
			this.radioGroup = ''
			this.btn_disabled = true
			this.loading_cost = true
			this.cost_data.courier_id = this.id_courier
			this.getCostRajaongkir(this.cost_data).then(()=> {
				this.loading_cost = false
			}).catch(() => {
				this.loading_cost = false
			})
		},
		chooseService(service, index) {
			this.courier_data = { expedition_name: '', expedition_service: '', expedition_price: '', etd: '' }
			this.courier_data.expedition_name = service.name

			/* cari id kurir yang di klik */
			service.costs.forEach((el, i) => {
				if ( i == index || i === index ) {
					this.courier_data.expedition_service = el.service
					this.courier_data.expedition_price = el.cost[0].value
					this.courier_data.etd = el.cost[0].etd
				}
			})

			if (this.courier_data.expedition_name) {
				this.btn_disabled = false
			}
		},
		saveCourier() {
			this.$emit('action', this.courier_data)
			this.modalHide()
		}
	}
};
</script>